import { render } from "./LabTestVersionModal.vue?vue&type=template&id=32884153"
import script from "./LabTestVersionModal.js?vue&type=script&lang=js"
export * from "./LabTestVersionModal.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__